<template>
  <div class="proposeList">
    <!-- <video id="qr-video"
            style="position: absolute; top: 0; left: 0; width: 100vw; height: 100vh; background-color: rgba(255,255,255); object-fit: cover;"
            autoplay></video> -->
    <div class="" style="position: absolute; left: 0; top: 100px; width: 100%; display: flex; justify-content: center">
      <div class="cover" style="margin-bottom: 0px">
        <video v-show="isScan" id="qr-video" playsinline="true" webkit-playsinline="true" style="object-fit: cover" autoplay></video>
        <canvas v-show="!isScan" id="qr-canvas"></canvas>
        <p class="line"></p>
        <!-- <p class="tip">将二维码放入框内，即可自动扫描</p> -->
        <div @click="$router.push('/Shoukuan')" style="position: absolute; bottom: -140px; left: -20px">
          <img style="width: 60px; height: 60px" src="@/assets/c/icon_wdm.png" alt="" />
          <div style="text-align: center; color: #fff; font-size: 14px; margin-top: 4px">{{ $t('new.wdm') }}</div>
        </div>
        <div @click="fileClick" style="position: absolute; bottom: -140px; right: -20px">
          <img style="width: 60px; height: 60px" src="@/assets/c/icon_xc.png" alt="" />
          <div style="text-align: center; color: #fff; font-size: 14px; margin-top: 4px">{{ $t('new.xc') }}</div>
        </div>
      </div>
    </div>
    <div class="fanview" @click="$router.go(-1)">
      <img src="@/assets/c/fan.png" class="bg" alt="" />
    </div>
    <input
      style="position: absolute; left: -1000px; top: 0"
      type="file"
      id="file"
      accept="image/jpeg,image/jpg,image/png"
      @change="changeImage"
    />

    <!-- 价值详情弹窗 -->
    <div class="first-gift-boxs-new" v-if="showPopup">
      <!-- fadeIn 渐渐显示 fadeInDown fadeInDownBig 从上往下 fadeInUpBig 从下往上 flipInY横向转动 zoomIn放大-->
      <div class="content-box animated" @click.stop="setPopup()" hover-class="bounce"></div>
      <div class="popviewnew">
        <img src="@/assets/c/img_tcbjpop.png" class="bg" alt="" />
        <div class="btitem">
          <div class="bilogo">
            <img src="@/assets/c/img_tx.png" class="img_logopop" alt="" />
          </div>
          <div class="maview">
            <div class="maitem">
              <img :src="qrCodeSrc" alt="QR Code" />
              <div style="display: flex; justify-content: center; margin-bottom: 20px">
                <span> {{ address }}</span>
              </div>
            </div>
          </div>
          <div @click="setPopup()" class="zhiview">
            <img src="@/assets/c/img_anbjpop.png" class="bg" alt="" />
            <div class="zhiitems">
              {{ $t('new.gb') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div style="position: fixed; top: 0px; height: 0px; color: #fff; z-index: 999999; padding: 20px;">
            <div>{{  gUM }}</div>
            <div>{{  imageData }}</div>
            <img  :src="imgSrc" alt="">
        </div> -->
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { ajaxData } from '@/api/ajax'
import { showToast } from '@/libs/util.js'
export default {
  data() {
    return {
      isScan: true,
      address: null,
      // 是否成功调用getUserMedia标识
      gUM: false,
      // 画布getContext对象
      gCtx: null,
      // 数据流对象
      imageData: null,
      // 视频展示对象
      videoDom: null,
      navigator: navigator,
      // 画布元素
      gCanvas: null,
      gCtx: null,
      webkit: false,
      moz: false,
      scan_timmer: null,
      qrCodeSrc: '',
      showPopup: false,
      imgSrc: ''
    }
  },
  created() {
    this.getData()
  },
  mounted() {
    this.videoDom = document.createElement('qr-video')
    this.gCanvas = document.getElementById('qr-canvas')
    this.gCtx = this.gCanvas.getContext('2d')
    this.init()
  },
  methods: {
    setPopup() {
      this.showPopup = !this.showPopup
      if (this.showPopup) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    getData() {
      let vm = this
      ajaxData('/user/jiandan', {}).then((response) => {
        vm.address = response.data.address
        vm.generateQRCode(vm.address)
      })
    },
    generateQRCode(text) {
      QRCode.toDataURL(text)
        .then((url) => {
          this.qrCodeSrc = url
        })
        .catch((err) => {
          console.error(err)
        })
    },
    init() {
      console.log('jsQR', jsQR)
      // 不同getUserMedia处理
      if (this.navigator.getUserMedia) {
        // 移动设备打开后置摄像头【 facingMode: "environment"】
        this.navigator.getUserMedia(
          {
            video: {
              facingMode: 'environment'
            }
          },
          this.success,
          this.error
        )
      } else if (this.navigator.mediaDevices.getUserMedia) {
        this.navigator.mediaDevices
          .getUserMedia({
            video: {
              facingMode: 'environment'
            },
            audio: false
          })
          .then(this.success)
          .catch(this.error)
      } else if (this.navigator.webkitGetUserMedia) {
        this.webkit = true
        this.navigator.webkitGetUserMedia(
          {
            video: {
              facingMode: 'environment'
            }
          },
          this.success,
          this.error
        )
      } else if (this.navigator.mozGetUserMedia) {
        this.moz = true
        this.navigator.mozGetUserMedia(
          {
            video: {
              facingMode: 'environment'
            }
          },
          this.success,
          this.error
        )
      }
    },
    success(stream) {
      this.videoDom = document.getElementById('qr-video')
      try {
        this.videoDom.srcObject = stream
      } catch {
        //这里是兼容写法
        let compatibleURL = window.URL || window.webkitURL
        this.videoDom.src = compatibleURL.createObjectURL(stream)
      }
      this.gUM = true
      this.scan_timmer = setTimeout(this.captureToCanvas, 700)
    },
    error(error) {
      showToast(this.$t('scan_auth_fail'))
      this.gUM = false
      return
    },
    captureToCanvas() {
      if (this.gUM) {
        this.gCanvas.width = 500
        this.gCanvas.height = 800
        this.gCtx.drawImage(this.videoDom, 0, 0)
        this.imgSrc = this.gCanvas.toDataURL()
        this.scan_timmer = setTimeout(this.captureToCanvas, 700)
        this.imageData = this.gCtx.getImageData(0, 0, 500, 800)
        const code = jsQR(this.imageData.data, this.imageData.width, this.imageData.height, {
          inversionAttempts: 'dontInvert'
        })
        if (code != null) {
          clearTimeout(this.scan_timmer)
          this.$router.replace({ path: `/Fukuan?address=${code.data}` })
        }
      }
    },
    goHome() {
      this.$router.go(-1)
    },
    fileClick() {
      document.getElementById('file').click()
    },
    changeImage(event) {
      const file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = () => {
        const img = new Image()
        img.onload = () => {
          // 创建canvas元素
          const canvas = document.getElementById('qr-canvas')
          // 设置画布尺寸
          canvas.width = img.width // 设置画布宽度
          canvas.height = img.height // 设置画布高度

          const context = canvas.getContext('2d')
          context.drawImage(img, 0, 0, canvas.width, canvas.height)
          // 在指定位置绘制图像
          const imageData = context.getImageData(0, 0, canvas.width, canvas.height)
          const code = jsQR(imageData.data, imageData.width, imageData.height)
          if (code) {
            this.$router.replace({ path: `/Fukuan?address=${code.data}` })
          } else {
            showToast(this.$t('recog_fail'))
          }
        }
        img.src = reader.result
      }
      reader.readAsDataURL(file)
    }
  }
}
</script>

<style scoped lang="less">
p {
  margin: 0;
  padding: 0;
}

.proposeList {
  width: 100%;
  height: 100vh;
  background: linear-gradient(to bottom, #121111, #6b6767);

  // 弹窗样式
  .first-gift-boxs-new {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    z-index: 300;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    transform: translate3D(0px, 0px, 0px) !important;

    .maview {
      width: 250px;
      margin: 0 auto;
      position: relative;
      .maitem {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
        img {
          width: 200px;
          height: 200px;
        }
      }
    }

    .content-box {
      position: absolute;
      width: 100%;
      height: 100%;
    }

    .popview {
      position: relative;
      width: 330px;
      background: #ffffff;
      border-radius: 15px;
      border: 1px solid #26e7fe;
      padding: 10px 30px 20px;
    }

    .jiahead {
      width: 104px;
      height: 37px;
      position: relative;
      margin: 0 auto;

      .jiaview {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 15px;
        color: #1a1a1a;
      }
    }

    .zhixiao {
      margin-top: 150px;
      width: 100%;
      height: 44px;
      background: #26e7fe;
      border-radius: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 14px;
      color: #1a1a1a;
    }
  }

  @keyframes lineanim {
    0% {
      transform: translateY(20px);
    }

    50% {
      transform: translateY(250px);
    }

    100% {
      transform: translateY(20px);
    }
  }

  .cover {
    height: 280px;
    width: 280px;
    border: 2px solid #35aab7;
    z-index: 200;
    position: relative;

    #qr-video {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      width: 100%;
      height: 100%;
    }

    #qr-canvas {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
    }
  }

  .line {
    width: 260px;
    height: 6px;
    -webkit-animation: lineamin 7s linear infinite;
    animation: lineanim 7s linear infinite;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    background: #5f68e8;
    background: linear-gradient(90deg, transparent, #3f7f87, #26e7fe, #3f7f87, transparent);
    position: absolute;
  }

  .tip {
    position: absolute;
    bottom: -30px;
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: #fff;
    opacity: 0.8;
  }

  .shade {
    height: 100%;
    background-color: #123;
    z-index: 3;
    margin: -30px;
    padding: 50px;
  }

  #qr-video {
    width: 750rem;
    height: 100%;
    background-color: black;
  }

  .mhead {
    // position: relative;
    // top: 50px;
  }
}

.popviewnew {
  width: 85%;
  position: relative;

  .btitem {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    .bilogo {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    .img_logopop {
      width: 60px;
      height: 60px;
      margin: 0 auto;
    }

    .biaoview {
      display: flex;
      flex-direction: column;
      margin: 10px 29px;

      .bname {
        width: 100%;
        display: block;
        text-align: center;
        font-weight: 500;
        font-size: 16px;
        color: #1a1a1a;
      }

      .bmiao {
        font-weight: 500;
        font-size: 12px;
        color: #1a1a1a;
        max-height: 170px;
        overflow: scroll;
      }
    }

    .zhiview {
      // margin-top: auto;
      width: 110px;
      position: relative;
      height: 39px;
      margin: auto auto 30px;

      .zhiitems {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 14px;
        color: #1a1a1a;
      }
    }
  }
}
</style>
